import React from "react"
import "./color.css"

function Phone() {
	return (
		<div className="phone">
			<svg width="24px" height="19px" viewBox="0 0 24 19" version="1.1">
				<title>ring_volume</title>
				<g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Outlined" transform="translate(-134.000000, -1262.000000)">
						<g id="Communication" transform="translate(100.000000, 1162.000000)">
							<g
								id="Outlined-/-Communication-/-ring_volume"
								transform="translate(34.000000, 98.000000)"
							>
								<g>
									<polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
									<path
										d="M23.71,16.67 C20.66,13.78 16.54,12 12,12 C7.46,12 3.34,13.78 0.29,16.67 C0.11,16.85 0,17.1 0,17.38 C0,17.66 0.11,17.91 0.29,18.09 L2.77,20.57 C2.95,20.75 3.2,20.86 3.48,20.86 C3.75,20.86 4,20.75 4.18,20.58 C4.97,19.84 5.87,19.22 6.84,18.73 C7.17,18.57 7.4,18.23 7.4,17.83 L7.4,14.73 C8.85,14.25 10.4,14 12,14 C13.6,14 15.15,14.25 16.6,14.72 L16.6,17.82 C16.6,18.21 16.83,18.56 17.16,18.72 C18.14,19.21 19.03,19.84 19.82,20.57 C20,20.75 20.25,20.85 20.52,20.85 C20.8,20.85 21.05,20.74 21.23,20.56 L23.71,18.08 C23.89,17.9 24,17.65 24,17.37 C24,17.1 23.89,16.85 23.71,16.67 Z M5.4,17.23 C4.74,17.6 4.11,18.03 3.53,18.5 L2.46,17.43 C3.37,16.68 4.36,16.04 5.41,15.53 L5.41,17.23 L5.4,17.23 Z M20.47,18.49 C19.88,18.01 19.26,17.59 18.6,17.22 L18.6,15.52 C19.64,16.03 20.63,16.67 21.54,17.42 L20.47,18.49 Z M21.16,6.26 L19.75,4.85 L16.19,8.4 L17.6,9.81 C17.6,9.81 21.05,6.29 21.16,6.26 Z M11,2 L13,2 L13,7 L11,7 L11,2 Z M6.4,9.81 L7.81,8.4 L4.26,4.84 L2.84,6.26 C2.95,6.29 6.4,9.81 6.4,9.81 Z"
										id="🔹-Icon-Color"
										fill="#1D1D1D"
									></path>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		</div>
	)
}

export default Phone
